import { generateClient } from "aws-amplify/api";

export const apiClient = generateClient();
